/**
 * @vuepress
 * ---
 * title: Concept lifting
 * ---
 */
import Transformer from "@/transformers/transformer";
import objectToForm from "@/utils/objectToForm";
import { assetURL } from "@/utils";

function fileTransformer({
  id,
  file,
  file_type: fileType,
  affected,
  visible_customer: visibleCustomer,
  is_active: isActive,
  add_date: addDate,
}) {
  const name = file.split("/").pop();
  return {
    id,
    file: assetURL(file),
    affected,
    fileType,
    visibleCustomer,
    isActive,
    name,
    addDate,
  };
}

/**
 * @class conceptTransformer
 * Concept transformer
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 */
class conceptTransformer extends Transformer {
  /**
   * @returns {Object}
   */
  static fetch({
    id,
    quantification,
    code,
    not_can_be_repaired: canNotBeRepaired,
    quantity,
    name,
    unit_price_EUR: unitPriceEUR,
    unit_price_MXN: unitPriceMXN,
    unit_price_USD: unitPriceUSD,
    construction_generator: constructionGenerator,
    panoramic_damage_photos: panoramicDamagePhotos,
    damage_photos,
    not_to_do: notToDo,
    reject_concept: rejectConcept,
    unit_measurement: unitMeasurement,
    concept,
    quantity_executed: quantityExecuted,
  }) {
    return {
      id,
      concept,
      quantification,
      code,
      canNotBeRepaired,
      quantity: +quantity,
      quantityExecuted: +quantityExecuted,
      backupQuantityExecuted: +quantityExecuted,
      name,
      unitPriceEUR,
      unitPriceMXN,
      unitPriceUSD,
      file: null,
      unitMeasurement,
      notToDo,
      rejectConcept, //! DEPRECATED
      files: constructionGenerator.length
        ? constructionGenerator
            .map((f) => fileTransformer(f.file))
            .filter((f) => f.isActive)
            .sort((a, b) => a.id - b.id)
        : [],
      panoramicDamagePhotos: panoramicDamagePhotos
        ? panoramicDamagePhotos
            .map((f) => fileTransformer(f.file))
            .filter((f) => f.isActive)
            .sort((a, b) => a.id - b.id)
        : [],
      damagePhotos: damage_photos.length
        ? damage_photos
            .map((f) => fileTransformer(f.file))
            .filter((f) => f.isActive)
            .sort((a, b) => a.id - b.id)
        : [],
    };
  }
  /**
   * Transform file to send
   * @param advance to send
   * @returns {Object}
   */

  static send({ id, quantityExecuted, notToDo, canNotBeRepaired }) {
    return {
      pk: id,
      quantity: quantityExecuted,
      not_can_be_repaired: canNotBeRepaired,
      not_to_do: notToDo,
    };
  }
  /**
   * Transform file to send
   * @param advance to send advance
   * @returns {Object}
   */

  static sendFile({ concept, file, image, visibleCustomer: visible_customer }) {
    const payload = {
      file: image || file,
      quantification_concept: concept,
      visible_customer,
    };
    return objectToForm(payload);
  }
}

export default conceptTransformer;



// WEBPACK FOOTER //
// ./src/transformers/purchase/lifting/concepts.js